export default __webpack_public_path__ + "static/media/0K9A1432.e9d36041.jpg";